import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import baseMessage from '../components/baseMessage.vue'
import { useRoute } from 'vue-router'

const __default__ = {
  name: 'DcCosFbuFollowUpRecordAdd'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const permissionBasic = {
  save: 'fbu_follow_add_btn'
}

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(baseMessage, {
            disabled: false,
            permissionPage: permissionBasic,
            archiveIds: _unref(route).query.archiveIds as Array<string>
          }, null, 8, ["archiveIds"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})